// Kept out of MessageGateDialog so callers mounted on every page (FriendRequestNotifier)
// don't pull the dialog and FaceVerificationCapture into the main bundle.
import type { SocialLinks } from "@/types/api";

/** Known platform keys only — the API's `social` relation uses `withDefault()` on the backend,
 *  so even a member with no social row gets a stub object back with a non-empty `userId` field
 *  (plus timestamps on a real row). `Object.values(social).some(...)` would pick those up as
 *  a "link", so check exactly the platform fields `SocialLinks` declares instead. */
const SOCIAL_LINK_KEYS: (keyof SocialLinks)[] = [
  "facebook",
  "twitter",
  "instagram",
  "snapchat",
  "linkedin",
  "tiktok",
  "yelp",
  "youtube",
  "google",
  "tripadvisor",
];

export function hasAnySocialLink(social: SocialLinks | undefined | null): boolean {
  if (!social) return false;
  return SOCIAL_LINK_KEYS.some((key) => {
    const v = social[key];
    return typeof v === "string" && v.trim().length > 0;
  });
}
